<template>
  <div class="layoutW">
    <Layout class="layBox">
      <Header>
        <div class="layout-logo">
          <img src="../../assets/images/khlogo.png" alt class="logoimg" width="100%">
        </div>
        <Col span="2" class="collapsedspan">
            <Icon @click.native="collapsedSider" :class="rotateIcon" :style="{margin: '0 20px'}" type="md-menu" size="24"></Icon>
        </Col>
        <div class="titleMenu">
          <Breadcrumb>
              <BreadcrumbItem href="#" >{{getbreakFirst}}</BreadcrumbItem>
            <BreadcrumbItem >{{getbreakTwo}}</BreadcrumbItem>
          </Breadcrumb>
        </div>
        <div class="user-avator-dropdown rightTop">
          <Dropdown v-for="(itemR,indexR) in getMenu" :name="indexR" :key="indexR" v-if="itemR.name=='日志'">
            <Badge v-if="itemR.name=='日志'">
              <Avatar :src="logList"/>
              <span class="current-user-info">{{itemR.name}}</span>
            </Badge>
            <Icon :size="18" type="md-arrow-dropdown"></Icon>
            <DropdownMenu slot="list" v-for="(menusChild,indexChild) in itemR.children"  :name="indexR+'-'+indexChild"  :key="menusChild.indexChild" v-if="menusChild.isShow && menusChild.isShow == 1" >
              <Dropdown-item @click.native="toUrl(menusChild)">
                <div class="logout">{{menusChild.name}}
                </div>
              </Dropdown-item>
            </DropdownMenu>
          </Dropdown>
          <Dropdown>
            <Badge>
              <Avatar :src="userAvator"/>
              <span class="current-user-info">设置</span>
            </Badge>
            <Icon :size="18" type="md-arrow-dropdown"></Icon>
            <DropdownMenu slot="list">
               <Dropdown-item >
                <div class="logout logoutL">{{getuserName}}
                </div>
                <div class="logout logoutleft">{{userNameNew}}
                </div>
              </Dropdown-item>
              <Dropdown-item @click.native="changePass">
                
                <div class="logout"><img :src="passImg"/> 修改密码&nbsp;
                </div>
              </Dropdown-item>
              <!-- <Dropdown-item @click.native="changeLanguage">
                <div class="logout"><img :src="LanguageImg"/> 系统语言&nbsp;
                </div>
              </Dropdown-item> -->
              <Dropdown-item @click.native="logout">
                <div class="logout"><img :src="backoutImg" />退出登录&nbsp;
                  <Icon type="log-out" color="#2d8cf0"></Icon>
                </div>
              </Dropdown-item>
              
            </DropdownMenu>
          </Dropdown>
          <div>版本号:3.5.1</div>
        </div> 
      </Header>
      <Layout>
        <Sider class="middle-layout" ref="side1" width="200" hide-trigger collapsible :collapsed-width="0" v-model="isCollapsed">
          <Menu  theme="light"  accordion    :active-name="activeName"    :open-names="[openName]"    ref="menu">
            <template v-for="(items,index) in getMenu">
              <Submenu v-if="items.code === 'pushLimitControl' && items.isShow == 1" :name="items.code">
                <div slot="title" v-if="items.parentId == 0 " @click="goUrl({index,indexChild:items,menusChild:items})">
                  <img class="menufather" :src="makeSrc(items.name)" alt>
                  <span>{{ items.name }}</span>
                </div>
              </Submenu>
              <Submenu :name="index" :key="index" v-else-if="items.isShow && items.isShow == 1 && items.name!='日志'">
                <template slot="title" v-if="items.parentId == 0 ">
                  <img class="menufather" :src="makeSrc(items.name)" alt>
                  <span @click="remblerOpenName(index)">{{items.name}}</span>
                </template>
                <!-- 新加字段名isShow，为0不显示，为1正常显示 -->
                <MenuItem  v-for="(menusChild,indexChild) in items.children"  :name="index+'-'+indexChild"  :key="menusChild.indexChild" v-if="menusChild.isShow && menusChild.isShow == 1" >
                  <span ref="menus" class="menuLi" @click="goUrl({index,indexChild,menusChild})">{{menusChild.name}}</span>
                </MenuItem>
              </Submenu>
            </template>
          </Menu>
        </Sider>
        <Layout class="layoutCon">
          <div class="tabW" v-if="getbreakTwo == '产品管理' || getbreakTwo == '类别管理' || getbreakTwo == '品牌管理' || getbreakTwo=='包装管理'">
            <Tabs @on-click="handleTabClick" ref="tabs">
              <Tab-pane label="产品管理" name="产品管理" ></Tab-pane>
              <Tab-pane label="类别管理" name="类别管理" ></Tab-pane>
              <Tab-pane label="品牌管理" name="品牌管理" ></Tab-pane>
              <Tab-pane label="包装管理" name="包装管理" ></Tab-pane>
            </Tabs>
          </div>
          <div class="tabW" v-if="getbreakTwo == '系统异常'">
            <Tabs @on-click="handleTabClick" ref="tabs">
              <!-- <Tab-pane label="工控机" name="工控机" ></Tab-pane> -->
              <Tab-pane label="管理平台" name="管理平台" ></Tab-pane>
              <Tab-pane label="手持机" name="手持机" ></Tab-pane>
            </Tabs>
          </div>
          <Content>
            <!--用于渲染匹配的组件  这是内容区域 -->
            <div :class="[ 'layout-content',{'layout-contentNew' : getbreakTwo == '产品管理' || getbreakTwo == '类别管理' || getbreakTwo == '品牌管理' || getbreakTwo == '包装管理'}]">
              <!-- 需要缓存的容器 -->
              <keep-alive>
                <router-view v-show="!getIframeState" v-if="$route.meta.keepAlive"></router-view>
              </keep-alive>
              <router-view v-show="!getIframeState" v-if="!$route.meta.keepAlive"></router-view>
              <iframe
                v-show="getIframeState"
                id="show-iframe"
                frameborder="0"
                name="showHere"
                scrolling="auto"
                width="100%"
                height="100%"
                :src="getIframeUrl"
              ></iframe>
            </div>
          </Content>
        </Layout>
      </Layout>
    </Layout>
    <Back-top :height="100" :bottom="200" :right="20" :duration="500">
      <div class="top">
        <img src="../../assets/images/返回顶部.png" alt>
      </div>
    </Back-top>
    <Modal
      ref="modal1"
      title=" "
      v-model="isloading"
      class="chart_model1"
      :mask-closable="true"
      @on-cancel="cancel"
      width
    >
      <img src="../../assets/images/searchLoading.png" alt>
    </Modal>
    <div class="changeModel" v-if="isChangeModel">
      <div class="changeBox">
        <p class="tipText" v-if="overData">{{errorTxt}}</p>
        <span class="closeBtn" v-if="!overData" @click="clsePop"><img src="../../assets/images/closeIcon.png" alt width="100%"></span>
        <changepassword></changepassword>
      </div>
    </div>
    <Modal v-model="languageShow" width="500"  @on-cancel="cancelLanguageShow"  class="erwm-confirm"  :mask-closable="false">
      <div slot="header" class="warnTit">
        <span class="tipTitle">系统语言</span>
      </div>
      <div class="languageList" >
        <div class="left" v-for="(item,index) in languageList" @click="chooseLan(index)">
          <img :src="EngPic" alt v-if="index == 0 && clickIndex ==0">
           <img :src="EngPicNo" alt v-if="index == 0 && clickIndex ==1">
          <img :src="chinaPic" alt  v-if="index == 1 && clickIndex ==0 ">
          <img :src="chinaOn" alt  v-if="index == 1 && clickIndex ==1 ">
          <span class="txt">
            <span class="imgIcon"  :class="{'imgIconOn':index==clickIndex}"></span>
            {{item}}</span>
        </div>
      </div>
    <!-- 底部按钮 -->
    <div class="buttonW">
      <button class="closePop" @click ='confirmChange' >立即切换</button>
    </div> 
  </Modal>
  <Modal v-model="isNewUser" width="800"  @on-cancel="newUserHide"  class="erwm-confirm newUserPop"  :mask-closable="false">
      <div slot="header" class="warnTit">
        <span class="newTitle">{{getuserName}},您好</span>
      </div>
      <div class="contentPop">
        <p class="titleTwo">{{titleTxt}}</p>
         <p>{{decTxt}}</p>
      </div>
    <!-- 底部按钮 -->
    <div class="buttonW">
      <button class="closePop useNowDiv" @click ='newUserHide' >立即开始使用</button>
    </div> 
  </Modal>
    <div class="logoutloading" v-if="logoutload">
        <Col class="demo-spin-col" span="24">
            <!-- <div class="demo-circular"></div> -->
            <Spin size="large" fix></Spin>
        </Col>
    </div>
  </div>
  
</template>
<script>
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";
import { checkBtn } from '../../utils/methods.js'
import changepassword from '../../view/myinfo/changepassword/changepassword'
import $ from 'jquery';
import { setTimeout } from 'timers';
import { MenuItem } from "iview";
import { name } from "file-loader";

export default {
   components: {
    changepassword
  },
  data() {
    return {
      titleTxt:'欢迎使用亨氏生产供应系统！',
      decTxt:'我们希望通过本平台协助企业快速建立满足国家与市场监管的企业全程溯源体系，同时帮助企业实现产业大数据生态系统的信息管理，完善企业供应链各环节的计划，协调，操作及数据监控',
      acitvename:'',
      isNewUser:false,
      clickIndex:0,
      languageList:['English','简体中文'],
      isChangeModel:false,
      overData:false,
      userNameNew:'',
      languageShow:false,
      //面包屑
      list: [{}],
      // 用户头像
      userAvator: require("../../assets/images/setSys.png"),
      imgUrl1: require("../../assets/images/基础数据.png"),
      imgUrl2: require("../../assets/images/生产供应.png"),
      imgUrl3: require("../../assets/images/仓储管理.png"),
      imgUrl4: require("../../assets/images/系统管理.png"),
      imgUrl5: require("../../assets/images/外链20x20px.png"),
      imgUrl6:require("../../assets/images/kefuImg.png"),
      imgUrl11:require("../../assets/images/shuju.png"),
      imgUrl7:require("../../assets/images/yichangjiankong.png"),
      imgUrl12:require("../../assets/images/mobile.png"),
      logList:require("../../assets/images/txtLog.png"),
      passImg:require("../../assets/images/passImg.png"),
      LanguageImg:require("../../assets/images/changeL.png"),
      backoutImg:require("../../assets/images/backOut.png"),
      EngPicOn:require("../../assets/images/English-y.png"),
      EngPicNo:require("../../assets/images/English.png"),
      chinaOn:require("../../assets/images/chinese-y.png"),
      chinaNo:require("../../assets/images/chinese.png"),
      EngPic:require("../../assets/images/English-y.png"),
      chinaPic:require("../../assets/images/chinese.png"),
      // 菜单展开项
      openData: {
        openName: "", //一级
        activeName: "" //二级
      },
      errorTxt:'为了您的账户安全，请修改密码',
      // openName:'',
      // activeName:'',
      menuData: [], //菜单数据
      iframeState: this.$store.state.app.iframeState,
      isCollapsed: false,
      showbread: false, //是否显示面包屑
      breakFirst: "",
      breakTwo: "" //二级面包屑
    };
  },
  computed: {
    logoutload(){
        let logoutload = localStorage.getItem('logoutload')
        return logoutload?(logoutload=='false'?false:true):false
      },
      // sideWidth(){
      //     // retrun (document.body.clientWidth>992)?200:'250'
      //      return (925<document.body.clientWidth&&document.body.clientWidth<1200)?'200':'250'
      // },
      rotateIcon () {
                return [
                    'menu-icon',
                    this.isCollapsed ? 'rotate-icon' : ''
                ];
            },
    // test
     openName(){
        if(sessionStorage.getItem('openData')==null){
              sessionStorage.setItem(
                "openData",
                JSON.stringify({ openName: '', activeName: '' })
              );
          
        }else{
            return JSON.parse(sessionStorage.getItem('openData')).openName
        }
       
     },
     activeName(){
        if(sessionStorage.getItem('openData')==null){
          
              sessionStorage.setItem(
                "openData",
                JSON.stringify({ openName: '', activeName: '' })
              );
        }else{
           return JSON.parse(sessionStorage.getItem('openData')).openName+'-'+JSON.parse(sessionStorage.getItem('openData')).activeName
        }
        // return JSON.parse(sessionStorage.getItem('openData')).openName+'-'+JSON.parse(sessionStorage.getItem('openData')).activeName
     },
    ...mapGetters([
      "isloading",
      "getIframeState",
      "getIframeUrl",
      "getMenu",
      "getuserName",
      "getToken",
      "getbreakFirst",
      "getbreakTwo"
    ]),
    rotateIcon() {
      return ["menu-icon", this.isCollapsed ? "rotate-icon" : ""];
    },
    menuitemClasses() {
      return ["menu-item", this.isCollapsed ? "collapsed-menu" : ""];
    }
  },
  methods: {
    newUserHide(){
      this.isNewUser=false;
      localStorage.setItem("firstLogin",'1');//不再是首次登陆
    },
    chooseLan(key){
      this.clickIndex = key;
      // this.EngPic=(key==0)?this.EngPicOn:this,EngPicNo;
      // this.chinaPic=(key==0)?this.chinaNo:this.chinaOn;
    },
    cancelLanguageShow(){
      this.languageShow = false;
    },
    confirmChange(){
      console.log("确认切换");
    },
    changeLanguage(){
      this.languageShow = true;
    },
    toUrl(nameMe){
      if(nameMe.name=='操作日志'){
        this.editLog();
      }else{
        this.loginLog();
      }
      let brnListNow=checkBtn(nameMe.children);
      // localStorage.removeItem('btnList');//先清除掉上个菜单存储的按钮权限
      // if(brnListNow){
      //   localStorage.setItem('btnList',JSON.stringify(brnListNow))
      // }
    },
    //操作日志
    editLog(){
      this.$router.push({
        path: "/main/editList"
      });
    },
    //登陆日志
    loginLog(){
      this.$router.push({
        path: "/main/loginList"
      });
    },
    //修改密码
    changePass(){
      this.isChangeModel = true;
      this.overData= false;

    },
    clsePop(){
      this.isChangeModel = false;
    },
    // 简易伸缩功能
      collapsedSider () {
          this.$refs.side1.toggleCollapse();
      },
    remblerOpenName(index){
      // 点击一级菜单时也记录 高亮
       sessionStorage.setItem(
        "openData",
        JSON.stringify({ openName: index, activeName: '' })
      );
    },
    handleTabClick(name){
      let url=name=='产品管理'?'Product':'anomalRecord'
      if(name=='产品管理'){
        url='Product'
      }else if(name=='类别管理'){
        url='Category'
      }else if(name=='品牌管理'){
        url='brand'
      }else if(name == '包装管理'){
        url='Packing'
      }else if(name == '工控机'){
        url= 'anomalRecord'
      }else if(name == '管理平台'){
        url = 'anomalRecord'
      }else if(name == '手持机'){
        url = 'mobile'
      }
      this.$router.push({
          name: url
        });
    },
    // 根据id 选择
    makeSrc(param) {
      var url = this.imgUrl11;
      //  1 9 13 28 62外链 42外链 68 
      switch (param) {
        case '基础数据':
          url = this.imgUrl1;
          break;
        case '报表统计':
          url = this.imgUrl1;
          break;
        case '生产管理':
          url = this.imgUrl2;
          break;
        case '仓储管理':
          url = this.imgUrl3;
          break;
        case '权限管理':
          url = this.imgUrl4;
          break;
        case '外链':
          url = this.imgUrl5;
          break;
        case 42:
          url = this.imgUrl5;
          break;
        case '稽查工具':
          url = this.imgUrl6;
          break;
        case '异常监控':
          url = this.imgUrl7;
          break;
        case '手持机菜单':
          url = this.imgUrl12;
          break;
        // case '推送限制管理':
        //   url = this.imgUrl4; // 使用系统管理图标
        //   break;
      }
      return url;
    },
    // 跳转
    goUrl(param) {
      // console.log(param)
      let { index, indexChild, menusChild } = param;
      //    let flag  = param.url.indexOf('http')||param.url.indexOf('https')
      if (
        menusChild.url.indexOf("http") != -1 ||
        menusChild.url.indexOf("https") != -1
      ) {
        this.$store.commit('setbreakFirst','外链')
        this.$store.commit('setbreakTwo',' ')
        this.$store.commit("setIframeState", true);
        let tokenNow = localStorage.getItem("281a10a70c6768fec8649705c8d2d060")
        if(tokenNow == null || tokenNow == ''){ //token为空，退出登陆后页面仍未关闭的情况
          this.$Message.error("token异常或者您已经退出登录");
          this.$router.push({
          path: "/"
        });
        }else{
          // console.log(menusChild.url)
          this.$store.commit(
          "setIframeUrl",
          menusChild.url +
            "?281a10a70c6768fec8649705c8d2d060=" +tokenNow);
          this.showbread = false;
        }
        if (!this.$router.hasOwnProperty("meta")) {
        }
      } else {
        this.$store.commit("setIframeState", false);
        let brnListNow=checkBtn(menusChild.children);
        // localStorage.removeItem('btnList');//先清除掉上个菜单存储的按钮权限
        this.$router.push({
          name: menusChild.url
        });
        // if(brnListNow){
        //   localStorage.setItem('btnList',JSON.stringify(brnListNow))
        // }
        console.log(brnListNow,'brnListNow')
        this.showbread = true;
      }

      sessionStorage.setItem(
        "openData",
        JSON.stringify({ openName: index, activeName: indexChild })
      );
    },

    refresh() {
      window.location.reload();
    },
    // 退出
    logout() {
      this.$store.dispatch("logout").then((res) => {
        // console.log('退出登陆')
          window.location.href = localStorage.getItem('hostUrl');//localStorage.getItem('hostName');//
          this.axios.defaults.headers.common["token"] = '123';
      });
    },
    collapsedSider() {
      this.$refs.side1.toggleCollapse();
    },
    changeMenu(actionName) {
      this.routerTo(actionName);
    },
    cancel() {
      // this.$store.commit('IS_LOADING',true)
    },
    test(){
        this.$router.push({
        name: "selftable"
      });
    },
    checkUser(id){
      this.axios.get(this.GLOBAL + "api/auth/checkLogin?userId="+id, {}).then((res) => {
        console.log(res.data.code,"qingqiujieguo")
        if(res.data.code != 1000){
          // this.isChangeModel = true;
          // this.overData = true;
          // this.errorTxt=res.data.msg;
          //401 跳出登录状态
           this.$Message.error(res.data.msg);
           window.location.href = localStorage.getItem("hostUrl")//localStorage.getItem('hostName');//
        }
      });
    },
  },
  created() {
    // this.openData = { openName:sessionStorage.getItem('openData').openName|| "", activeName: sessionStorage.getItem('openData').activeName||"" };
    // this.isNewUser=localStorage.getItem("firstLogin")==1?false:true;
  },
  watch: {
    $route(to, from) {
      localStorage.setItem('breakFirst',to.meta.parentname)
      localStorage.setItem('breakTwo',to.meta.name)
      this.$store.commit('setbreakFirst',localStorage.getItem('breakFirst'))
      this.$store.commit('setbreakTwo',localStorage.getItem('breakTwo'))
    },
    getbreakTwo(val, oldVal){//普通的watch监听
        console.log("a: "+val, oldVal);
        if(val=='产品管理' || val=='类别管理' || val=='品牌管理' || val=='包装管理'){
          setTimeout(()=>{
            this.$refs.tabs.activeKey = val;
          })
        }else if(val=='异常监控'){
          setTimeout(()=>{
            this.$refs.tabs.activeKey = '管理平台';
          })
        }
    },
    
  },
  mounted() {
    this.userNameNew = localStorage.getItem('userNameNew')
    var devtoken = "281a10a70c6768fec8649705c8d2d060"; //生产环境token
    this.axios.defaults.headers.common["token"] = localStorage.getItem(
      devtoken
    ); //token
    var  url = window.location.href;
    var site = url.lastIndexOf("\/");
    let nameUrl=url.substring(site + 1, url.length);
    if(nameUrl=='Category'){
      this.$refs.tabs.activeKey = '类别管理'
    }else if(nameUrl=='brand'){
      this.$refs.tabs.activeKey = '品牌管理'
    }else if(nameUrl=='Packing'){
      this.$refs.tabs.activeKey = '包装管理'
    }else if(nameUrl=='Product'){
      this.$refs.tabs.activeKey = '产品管理'
    }else if(nameUrl=='anomalRecord'){
      this.$refs.tabs.activeKey = '管理平台'
    }
    //检查登陆状态
    if(localStorage.getItem("isShow")=='true'){
      console.log(localStorage.getItem("isShow"),'jinru')
      // this.checkUser(localStorage.getItem("thisUserId")) 校验密码功能 暂时注掉
    }
    // console.log(localStorage.getItem("isShow"))
    // this.$refs.tabs.activeKey=this.getbreakTwo =='产品管理'?'产品管理':'工控机';
  //  this.getMenu.push({name:'异常查询',parentId: 0,id:100,weight: 25},{name:'数据查询',parentId: 0,id:99,weight: 23})

  }
};
</script>

<style lang="less">
.logoutloading {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 999;
    top: 0;
    left:0;
    background: rgba(0,0,0,0.5);
    .demo-spin-col{
      height: 100%;
      position: relative;
      border: 1px solid #eee;
      display: flex;
      justify-content: center;
      align-items: center;
      .ivu-spin-fix {
        background: rgba(0,0,0,0.5);
      }
    }
    .demo-circular {
      width: 50px;
      height: 50px;
      border-radius: 25px;
      border-top: 5px solid #000;
      border-right: 5px solid #000;
      animation: ani-demo-spin 1s linear infinite;
    }
}

@keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
}

.briderTop{
  border-top: 47px solid #f0f2f4;
}
.changeModel{
  position: fixed;
  width:100%;
  height:100%;
  left:0;
  top:0;
  background: rgba(0,0,0,.3);
  z-index:999;
  .changeBox{
    width:600px;
    position:fixed;
    background:#fff;
    left:50%;
    top:50%;
    padding-top:40px;
    transform: translate(-50%,-50%);
    .tipText{
      text-align: center;
      color:#ff0000;
      font-size: 16px;
    }
    .changePwdModal{
      margin-left:0;
      padding-top:15px;
      .ivu-col-span-12{
        width:90%;
        padding-left:5%;
      }
    }
  }
}
.layout-header-barNew{
  line-height: 40px;
}
// 表格的列表字段
.layout-content-main .ivu-table .ivu-table-cell{
  padding-left: 5px;
  padding-right: 5px;
}
.layout-content-main .inv-table .ivu-icon-ios-arrow-forward{
   margin-left: 0px !important;
}
.tabW{
  width: 100%;
  padding:5px 20px 10px;
  box-lines: border-box;
  background:#f0f2f4;
  .ivu-tabs-bar{
    border-bottom:none;
  }
}
.ivu-tabs-nav .ivu-tabs-tab-active{
  color:#008fcd;
}
.ivu-tabs-ink-bar{
  background: #008fcd;
}
// 表格的loading样式
 .demo-spin-icon-load{
        animation: ani-demo-spin 1s linear infinite;
    }
    @keyframes ani-demo-spin {
        from { transform: rotate(0deg);}
        50%  { transform: rotate(180deg);}
        to   { transform: rotate(360deg);}
    }
    .demo-spin-col{
        height: 100px;
        position: relative;
        border: 1px solid #eee;
    }
   .ivu-spin-fix { 
      min-height: 500px;
      background-color: rgba(255,255,255,.7);
}
// 仓储箭头的样式

.collapsedspan{
  margin-top: 8px;
}
// 伸缩的图标样式
 .rotate-icon{
        transform: rotate(-90deg);
    }
// 导入的图标样式
.ivu-icon-ios-cloud-upload:before {
    content: "\F183";
    color: #008fcd;
}
// 搜索容器
.common_con {
  // 页面的按钮颜色
  .layout-content-main {
    padding: 20px;
    padding-top: 0px;
  }
  .ivu-btn-primary {
    background-color: #008fcd;
    color: #fff;
    &:hover {
      background-color: #48add9;
    }
    &:active {
      background-color: #007aaf;
    }
  }
  .pagestyle .ivu-page-item-active {
    background-color: #008fcd;
  }
  .inputspan7 {
    width: 260px;
  }
  .inputspan8 {
    //两个字的
    width: 260px;
  }
  .inputspan9 {
    //四个字的
    width: 320px;
    margin-right: 20px;
  }
  .topbutton {
    background-color: #f0f2f4;
    padding: 20px;
    // button
    .height42 {
      height: 36px;
      margin-right: 10px;
    }
    .size16 {
      font-size: 14px;
    }
  }
  .topsearch {
    padding: 20px;
    // 搜索的span
    .ivu-input-group-append,
    .ivu-input-group-prepend {
      background-color: #fff;
      color: #008fcd;
      font-size: 14px;
      font-weight: 500;
    }
    .ivu-col-span-8 {
      width: 320px;
      .ivu-input-group {
        width: 320px;
        .ivu-input {
          width: 220px;
          height: 36px;
          margin-right: 10px;
          display: inline-block;
        }
      }
    }
    .ivu-col-span-9 {
      width: 315px;
      .ivu-input-group {
        width: 315px;
        .ivu-input {
          width: 220px;
          height: 36px;

          display: inline-block;
        }
      }
    }
  }
}


// 警告提示
.proinf-confirm {
  .ivu-modal-header {
    height: 47px;
  }
  .warnTit {
    height: 46px;
  }
  .warnTit span {
    color: #121212;
    position: absolute;
    left: 0;
    top: 0;
    font-size: 18px;
    height: 47px;
    width: 100px;
    line-height: 46px;
    margin-left: 20px;
    border-bottom: 2px solid #008fcd;
    display: inline-block;
    float: left;
    font-size: 16px;
    text-align: center;
  }
  .titWord {
    text-align: center;
    color: #008fcd;
    font-size: 16px;
    // border: 1px solid red;
    font-weight: bold;
  }
  .ivu-modal-body {
    padding-top: 40px;
    padding-left: 20px;
    padding-right: 20px;
  }
  .ivu-modal-footer {
    border-top: none !important;
    padding: 0px;
    padding-bottom: 40px;
  }
  .ivu-btn:nth-child(1) {
    background-color: #008fcd;
    color: #fff;
    &:hover {
      background-color: #48add9;
    }
    &:active {
      background-color: #007aaf;
    }
  }
  .ivu-btn:nth-child(2) {
    margin-right: 180px;
    margin-left: 40px;
    border: 1px solid #008fcd;
    background-color: #fff;
    color: #008fcd;
    &:hover {
      color: #48add9;
      border: 1px solid #48add9;
    }
    &:active {
      color: #007aaf;
      border: 1px solid #007aaf;
    }
  }
}
.heightsearch{
   .ivu-modal-footer {
    border-top: none !important;
    padding: 0px;
    padding-bottom: 30px !important;
  }
  .ivu-btn:nth-child(1) {
   
    background-color: #008fcd;
    color: #fff;
    &:hover {
      background-color: #48add9;
    }
    &:active {
      background-color: #007aaf;
    }
  }
  .ivu-btn:nth-child(2) {
    
    border: 1px solid #008fcd;
    background-color: #fff;
    color: #008fcd;
    &:hover {
      color: #48add9;
      border: 1px solid #48add9;
    }
    &:active {
      color: #007aaf;
      border: 1px solid #007aaf;
    }
  }
  .ivu-btn {
     padding: 0px;
     padding-left: 15px;
     padding-right: 15px;
  }
}

// 一行的样式
.add-modal {
  // 头部
  .ivu-modal .ivu-modal-content .ivu-modal-header {
    padding: 0px;
    height: 47px;
    line-height: 47px;
    .addTit {
      width: 140px;
      border-bottom: 1px solid #008fcd;
      height: 47px;
      line-height: 47px;
      margin-left: 20px;
      text-overflow:ellipsis;overflow: hidden;white-space: nowrap;
    }
    .addTit img {
      // padding-left: 20px;
      width: 16px;
      height: 16px;
    }
    .addTit span {
      color: #121212;
      font-size: 16px;
      font-weight: 500;
      margin-left: 10px;
      display: inline-block;
    }
  }
  // 内容区
  .ivu-modal .ivu-modal-content .ivu-modal-body {
    padding: 20px 40px;
    // 一行的
    .ivu-col-span-24 .ivu-form-item {
      display: block;
      .ivu-form-item-label {
        font-size: 14px;
        padding: 10px 6px 10px 0 !important;
      }
      .ivu-form-item-content {
        .ivu-select-single .ivu-select-selection {
          .ivu-select-input {
            font-size: 14px;
          }
          .ivu-select-input[disabled] {
              background-color: #f0f2f4;
               color: #777777;
          }
        }
         .ivu-input[disabled], fieldset[disabled] .ivu-input {
                background-color: #f0f2f4;
                color: #777777;
            }
        // 地址联动input
        .ivu-cascader-disabled .ivu-cascader-label {
              background-color: #f0f2f4;
               color: #777777;
               font-size: 14px;
          }
      }
    }

    // 两行的  后面有文字
    .ivu-col-span-11 {
      width: 50%;
      //  border: 1px  solid red;
    }
    .ivu-col-span-11 .ivu-form-item {
      margin-bottom: 22px;
      .ivu-form-item-label {
        font-size: 14px;
        padding: 10px 6px 10px 0 !important;
      }
      .ivu-form-item-content {
        // border: 1px solid red
        .ivu-input-wrapper {
          //给定宽
          width: 240px;
          //  height: 36px;
          .ivu-input {
            width: 240px;
          }
        }
       
        .ivu-select-single .ivu-select-selection {
          width: 240px;
          //  height: 36px;
          .ivu-select-input {
            //  border: 1px solid red;
            width: 240px;
          }
          .ivu-select-input[disabled] {
              background-color: #f0f2f4;
              color: #777777;
          }
          
        }
         .ivu-input[disabled], fieldset[disabled] .ivu-input {
                background-color: #f0f2f4;
                color: #777777;
            }
      }
    }
    // 两行的  后面有文字  生产任务这块
    .ivu-col-span-12 {
      width: 50%;
      //  border: 1px  solid red;
    }
    .ivu-col-span-12 .ivu-form-item {
      margin-bottom: 22px;
      .ivu-form-item-label {
        font-size: 14px;
        padding: 10px 6px 10px 0 !important;
      }
      .ivu-form-item-content {
        // border: 1px solid red
        .ivu-input-wrapper {
          //给定宽
          //  width: 160px;
          //  height: 36px;
          .ivu-input {
            //  width: 160px;
          }
        }
        .ivu-select-single .ivu-select-selection {
          // width: 160px;
          //  height: 36px;
          .ivu-select-input {
            //  border: 1px solid red;
            // width: 160px;
          }
          .ivu-select-input[disabled] {
               background-color: #f0f2f4;
              color: #777777;
          }
          
        }
         .ivu-input[disabled], fieldset[disabled] .ivu-input {
                background-color: #f0f2f4;
                color: #777777;
            }
      }
    }

    // 按钮
    .ivu-btn-primary {
      background-color: #008fcd;
      color: #fff;
      &:hover {
        background-color: #48add9;
      }
      &:active {
        background-color: #007aaf;
      }
    }
  }
  // 尾部
  .ivu-modal .ivu-modal-content .ivu-modal-footer {
    border-top: none !important;
    padding: 0px;
  }
}
//  导入弹框样式
.import-modal {
  .ivu-modal-header {
    padding: 0px;
    height: 47px;
    line-height: 47px;
  }
  .addTit {
    width: 120px;
    border-bottom: 1px solid #008fcd;
    height: 47px;
    line-height: 47px;
    margin-left: 20px;
  }
  .addTit img {
    // padding-left: 20px;
    width: 16px;
    height: 16px;
  }
  .addTit span {
    color: #121212;
    font-size: 16px;
    font-weight: 500;
    margin-left: 10px;
    display: inline-block;
  }
  // 按钮
  .ivu-btn-primary {
    background-color: #008fcd;
    color: #fff;
    &:hover {
      background-color: #48add9;
    }
    &:active {
      background-color: #007aaf;
    }
  }
}


// 产品管理的弹窗

    .productAdd{
        .ivu-input{
        height: 36px;
      }
      .ivu-select-input{
        height: 36px;
      }
      .ivu-select-input {
        height: 36px;
        line-height: 36px;
      }
      .ivu-select-single{
          height: 36px;
        line-height: 36px;
      }
  
    }
  

  @media (min-width: 992px) {
  .common_con {
    // 页面的按钮颜色

      //  页面头部
      .topbutton {
        padding: 15px;
      }
      .topsearch {
        padding: 15px;
        // 搜索的span
        .ivu-input-group-append,
        .ivu-input-group-prepend {
          background-color: #fff;
          color: #008fcd;
          font-size: 14px;
          font-weight: 500;
          height: 32px;
        
        }
        .ivu-col-span-8 {
          width: 230px;
          .ivu-input-group {
            width: 230px;
            .ivu-input {
              width: 140px;
              height: 32px;
              margin-right: 8px;
            }
          }
        }
        .ivu-col-span-9 {
          width: 230px;
          .ivu-input-group {
            width: 230px;
            .ivu-input {
              width: 140px;
              height: 32px;
            }
          }
        }
      }
    }
  
}
@media (min-width: 1200px) {
  .common_con {

      //  页面头部
      .topbutton {
        background-color: #f0f2f4;
        padding: 20px;
        // button
        .height42 {
          height: 36px;
          margin-right: 10px;
        }
        .size16 {
          font-size: 14px;
        }
      }
      .topsearch {
        padding: 20px;
        // 搜索的span
        .ivu-input-group-append,
        .ivu-input-group-prepend {
          background-color: #fff;
          color: #008fcd;
          font-size: 14px;
          font-weight: 500;
        }
        .ivu-col-span-8 {
          width: 250px;
          .ivu-input-group {
            width: 250px;
            .ivu-input {
              width: 160px;
              height: 36px;
              margin-right: 10px;
              display: inline-block;
              font-size: 14px;
            }
          }
        }
        .ivu-col-span-9 {
          width: 250px;
          .ivu-input-group {
            width: 250px;
            .ivu-input {
              width: 160px;
              height: 36px;
              font-size: 14px;
              display: inline-block;
            }
          }
        }
      }
    }

}
//布局优化修改 2021-05-08  by-mlj
.layout-logo{
  width:190px; 
  padding:10px 20px 0 20px;
  height: 64px;
}
.ivu-layout-header{
  padding-left:0;
  position: relative;
}
.topRow{
  position: fixed;
  top:0;
  left:0;
}
.collapsedspan{
  position: absolute;
  left:200px;
  top:0px;
  margin:0;
}
.titleMenu{
  width:300px;
  position: absolute;
  left:300px;
  top:0;
}
.user-avator-dropdown{
  position: absolute;
  right:20px;
  top:0;
  width: 260px;
  display: flex;
  justify-content: space-around;
}
.ivu-layout-sider .ivu-menu-vertical .ivu-menu-item span{
  padding-left: 10px;
  font-size: 13px;
}
.ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu){
  background:none;
}
.ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu):after{
  display: none;
}
.titleMenu .ivu-breadcrumb>span:last-child{
  color: #121212;
  font-weight: 500;
  font-size: 14px;
}
.closeBtn{
  position: absolute;
  right:15px;
  top:15px;
  width:25px;
  opacity: .4;
}
.rightTop .ivu-avatar{
  border-radius: 0;
  img{
    width:80%;
    height: 80%;
  }
}
.newTitle{
  font-size: 28px;
  color:#333;
}
.newUserPop{
  .ivu-modal-content{
    padding:50px 60px;
  }
}
.contentPop{
  padding:20px 0 30px;
  font-size: 14px;
  line-height:26px;
   .titleTwo{
    margin-bottom: 35px;
  }
}
.erwm-confirm .buttonW .useNowDiv{
  padding: 10px 12px;
  margin-top:15px;
}

</style>

<style lang="less" scoped>
  .menu-item-text {
    font-size: 14px !important;
    font-weight: 500;
    color: #121212;
  }
</style>


// WEBPACK FOOTER //
// src/components/main/main.vue